import React, {
  useCallback, useContext, useEffect, useMemo, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Button, Badge, Alert, Tabs, Tab,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCompress, faExpand } from '@fortawesome/free-solid-svg-icons';
import api from '../../api/req';
import { CiatAppContext } from '../../providers';
import { Loader } from '../../components/bootStrap';
import ReportsSubList from './reportsSubList';
import { reportPropType } from './item';

const CHAPTER_NAMES = {
  0: 'Для всіх бюджетів',
  1: 'Для мого бюджету',
  2: 'Для моєї установи',
  3: 'Для мене',
};

const chapters = [3, 2, 1, 0];

function ReportsList({
  reports, favorites, onToggleFavorites, showChapters,
}) {
  const [compactView, setCompactView] = useState(false);
  const [currentChapter, setCurrentChapter] = useState('0');
  // const chapters = useMemo(
  //   () => [...new Set(reports.map((report) => report.kind))].sort((a, b) => b - a),
  //   [reports],
  // );
  // useEffect(
  //   () => {
  //     if (!chapters.map((c) => String(c)).includes(currentChapter) && chapters.length > 0) {
  //       setCurrentChapter(String(chapters[0]));
  //     }
  //   },
  //   [chapters, currentChapter],
  // );
  const { auth } = useContext(CiatAppContext);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(false);

  const refedSettings = useRef();
  refedSettings.current = {
    compactView,
  };

  const settingsURL = useMemo(() => '/api/auth/profilesettings/reports-panel/', []);

  const onSaveSettings = useCallback(
    () => {
      const asyncLoader = async () => {
        const response = await api.post(settingsURL, auth, { settings: refedSettings.current });
        if (response.ok) {
          return true;
        }
        throw new Error(`Помилка при збереженні налаштувань (${response.status} ${response.statusText})`);
      };
      setLoading(true);
      asyncLoader(refedSettings.current)
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    },
    [auth, settingsURL],
  );

  const onLoadSettings = useCallback(
    () => {
      const asyncLoader = async () => {
        const response = await api.get(settingsURL, auth);
        if (response.ok) {
          return response.json();
        }
        throw new Error(`Помилка при завантаженні налаштувань (${response.status} ${response.statusText})`);
      };
      setLoading(true);
      setErr(null);
      asyncLoader()
        .then((data) => {
          refedSettings.current = data.settings || {};
          setCompactView(refedSettings.current.compactView || false);
        })
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    },
    [auth, settingsURL],
  );
  useEffect(() => () => onSaveSettings(), [onSaveSettings]);
  useEffect(() => {
    onLoadSettings();
  }, [onLoadSettings]);
  return (
    <>
      {loading && (
      <Loader />
      )}
      {err && (
        <Alert variant="danger">
          {err}
        </Alert>
      )}
      <div className="my-3 me-4 text-end">
        <Button className="me-1" onClick={() => setCompactView(true)} title="Зманшити іконки">
          <FontAwesomeIcon icon={faCompress} />
        </Button>
        <Button onClick={() => setCompactView(false)} title="Збільшити іконки">
          <FontAwesomeIcon icon={faExpand} />
        </Button>
      </div>
      {showChapters ? (
        <Tabs activeKey={currentChapter} onSelect={(ch) => setCurrentChapter(ch)}>
          {chapters.map((chapter) => {
            const cr = reports.filter((report) => report.kind === chapter);
            return (
              <Tab
                eventKey={String(chapter)}
                title={(
                  <>
                    {CHAPTER_NAMES[chapter]}
                    <Badge bg="secondary" className="ms-2">{cr.length}</Badge>
                  </>
                  )}
              >
                <ReportsSubList
                  compactView={compactView}
                  reports={cr}
                  favorites={favorites}
                  onToggleFavorites={onToggleFavorites}
                />
              </Tab>
            );
          })}
        </Tabs>
      ) : (
        <ReportsSubList
          compactView={compactView}
          reports={reports}
          favorites={favorites}
          onToggleFavorites={onToggleFavorites}
        />
      )}
    </>
  );
}

ReportsList.propTypes = {
  reports: PropTypes.arrayOf(reportPropType).isRequired,
  favorites: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleFavorites: PropTypes.func.isRequired,
  showChapters: PropTypes.bool,
};

ReportsList.defaultProps = {
  showChapters: false,
};
export default ReportsList;
